import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
// Component
import { LoggingService } from './core/utils/logging.service';
import { Title } from '@angular/platform-browser';
import { environment } from '../environments/environment';
import { AiFlowCrmSubscription } from '@geeesy/type-aiflow';

import CountryList from 'country-list-with-dial-code-and-flag';
import { PhoneNumberFormat, PhoneNumberUtil } from 'google-libphonenumber';
import { LanguageConfigService } from './pattern/language-config/language-config.service';
import { concatMap, Subject, takeUntil, tap } from 'rxjs';
import { IPreferences } from './core/services/dexie-indexed-db.service';
import { MappingService } from './core/utils/mapping.service';

const X_PHASE = import.meta.env.NG_APP_X_PHASE;
const AUTH0_AUDIENCE = import.meta.env.NG_APP_AUTH0_AUDIENCE;

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  private readonly loggingService = inject(LoggingService);
  private readonly title = inject(Title);
  private readonly languageConfigService = inject(LanguageConfigService);
  private readonly mappingService = inject(MappingService);

  private destroy$ = new Subject<void>();

  constructor() {
    this.loggingService.log(
      '🅰️0️⃣--AppComponent---------------------------------------------------------------------------------------'
    );
    this.loggingService.info('PHASE', X_PHASE);
    this.loggingService.log('AUTH0_AUDIENCE', AUTH0_AUDIENCE);
    this.loggingService.error('Check @geeesy/type-aiflow', AiFlowCrmSubscription.PackageType.COMPANY);
    const isProd = environment.phase === 'prod';
    this.title.setTitle(`AIFLOW CRM ${isProd ? '' : `(${environment.phase})`}`);
    this.loggingService.info('UPDATE | 27/08/2026 | 20:12 PM');
    CountryList.setPhoneNumberUtil(PhoneNumberUtil.getInstance());

    // const getInstance = PhoneNumberUtil.getInstance();
    // this.loggingService.log('PHONE UTIL', getInstance);

    const getAllCountryCode = CountryList.getAll();
    this.loggingService.log('ALL COUNTRY CODE', getAllCountryCode);

    // const th = CountryList.findOneByCountryCode('th');
    // this.loggingService.log('TH', th);
    // if (th) {
    //   const formatPhoneNum = th.formatPhoneNumber('0123456789');
    //   this.loggingService.log('TH FORMAT', formatPhoneNum);
    //   const flagSvg = CountryFlagSvg[th.code];
    //   this.loggingService.log(flagSvg); // This will return svg string
    //   const format2 = th.formatPhoneNumber('0123456789', PhoneNumberFormat.NATIONAL);
    //   this.loggingService.log('TH FORMAT 2 : ', format2);
    //   const format3 = th.formatPhoneNumber(formatPhoneNum, PhoneNumberFormat.NATIONAL);
    //   this.loggingService.log('TH FORMAT 3 : ', format3);
    // }
    this.checkLanguageDexieIDB();
    this.checkMappingService();
  }

  checkLanguageDexieIDB() {
    this.languageConfigService
      .getLangStateIdb()
      .pipe(
        takeUntil(this.destroy$),
        tap((res: IPreferences | undefined) => {
          this.loggingService.warn('APP | Dexie Language State 📝📝📝', res);
        }),
        concatMap((res: IPreferences | undefined) => {
          return this.languageConfigService.switchLanguageIdb(res?.language || 'th');
        })
      )
      .subscribe();
  }

  checkMappingService() {
    this.mappingService
      .convertMobileCountryCodeByFormat(['+12843001111'], 'VG', PhoneNumberFormat.NATIONAL)
      .subscribe((res) => {
        this.loggingService.log('CHECK MAPPING SERVICE', res);
      });
  }

  onDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
